export default function Fills() {
  return (
    <div className="p-4">
      <h1>Fills</h1>
    </div>
  );
}
